<template>
    <v-card v-if="tryouts">
        <v-card-title>Try out</v-card-title>
        <v-card-text>
            <div class="text-right">
                <v-btn
                    :to="{
                        name: 'period.tryout.create',
                        params: { period_id: $route.params.period_id },
                    }"
                    color="primary"
                    rounded
                >
                    Buat baru
                </v-btn>
            </div>

            <v-list
                two-line
                elevation="1"
            >
                <v-list-item
                    v-for="tryout in tryouts"
                    :key="tryout.hash"
                    :to="{
                        name: 'period.tryout.detail',
                        params: {
                            period_id: $route.params.period_id,
                            hash: tryout.hash,
                        },
                    }"
                >
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ tryout.title }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                            Dirilis {{ tryout.released_at }}
                        </v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-action>
                        <v-icon>mdi-chevron-right</v-icon>
                    </v-list-item-action>
                </v-list-item>
            </v-list>
        </v-card-text>
    </v-card>
</template>

<script>
import { parseFromServer } from '@/plugins/moment'

export default {
    data: () => ({
        tryouts: null,
    }),

    async created() {
        const response = await this.$api.get(
            `period/${this.$route.params.period_id}/tryout`
        )
        this.tryouts = response.data.tryouts.map((e) => {
            return {
                ...e,
                released_at: parseFromServer(
                    e.released_at
                ).formatShortDayAndTime(),
            }
        })
    },
}
</script>
